import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import styled from "styled-components";
import {RiAccountCircleFill, RiEditFill, RiPencilFill} from "react-icons/ri";
import {updateProfile} from "../../Redux/actions/authAction";
import multiavatar from '@multiavatar/multiavatar/esm'
import PuffLoader from "react-spinners/PuffLoader";

const Settings = ({user, updateProfile}) => {
    const [showAvatars, setShowAvatars] = useState(false);
    const [avatarCodes, setAvatarCodes] = useState(null);
    const [selectedAvatarCode, setSelectedAvatarCode] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [isEdit, setIsEdit] = useState(false);
    const [formData, setFormData] = useState({
        status: '',
        name: '',
        email: '',
        phone: '',
        birthDate: '',
        location: '',
    });
    const {status, name, phone, birthDate, location} = formData;

    useEffect(() => {
        if (!!user.avatarImage)
            setAvatarCodes(user.avatarImage);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = async (e) => {
        e.preventDefault();
        let reqData = {...formData, 'avatarImage': selectedAvatarCode}
        updateProfile(reqData);
        setIsEdit(false);
    };

    const getAvatars = async () => {
        setIsLoading(true);
        const imageCodes = [];
        for (let i = 0; i < 12; i++) {
            const imageCode = Math.round(Math.random() * 1000);
            imageCodes.push(imageCode);
        }
        setAvatarCodes(imageCodes);
        setIsLoading(false);
    }

    const avatarChange = () => {
        setShowAvatars(!showAvatars);
        if (!showAvatars)
            getAvatars();
    }

    const selectAvatar = (avatar) => {
        setShowAvatars(false);
        editForm();
        setSelectedAvatarCode(avatar);
    }

    const editForm = () => {
        setFormData(user);
        setIsEdit(true);
    }

    const onChange = (e) =>
        setFormData({...formData, [e.target.name]: e.target.value});

    return (
        <Container>
            <div style={{paddingTop: 20}}>
                <div className='header'>
                    <h3>Settings</h3>
                </div>
            </div>
            <div className='avatar-container'>
                <div className='avatar-image-container'>
                    {
                        selectedAvatarCode ?
                            <div className='avatar'
                                 dangerouslySetInnerHTML={{__html: multiavatar(selectedAvatarCode)}}>
                            </div>
                            :
                            user.avatarImage ?
                                <div>
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <div style={{position: "relative"}} className='avatar'
                                             dangerouslySetInnerHTML={{__html: multiavatar(user.avatarImage)}}>
                                        </div>
                                        <RiPencilFill onClick={() => avatarChange()} className='avatar-edit'/>
                                    </div>
                                </div>
                                :
                                <div>
                                    <div style={{position: "relative", display: "inline-block"}}>
                                        <RiAccountCircleFill className='avatar-icon'/>
                                        <RiPencilFill onClick={() => avatarChange()} className='avatar-edit'/>
                                    </div>
                                </div>
                    }
                </div>
                {!showAvatars ? null :
                    <div className='select-container'>
                        <div className='select-box'>
                            {!isLoading ?
                                avatarCodes.map((avatar, index) => {
                                    return (
                                        <div key={index} className='avatar'
                                             onClick={() => selectAvatar(avatar)}
                                             dangerouslySetInnerHTML={{__html: multiavatar(avatar)}}>
                                        </div>
                                    );
                                })
                                :
                                <div className='spinner-container'><PuffLoader color="#7269EF"/></div>
                            }
                        </div>
                    </div>}

                <h4>{user.name}</h4>
            </div>
            <div className='status-container'>
                <div className={`profile-edit ${isEdit ? 'hidden' : null}`} onClick={() => editForm()}>
                    <RiEditFill/>
                    <p>Edit</p>
                </div>

                {
                    isEdit ?
                        <textarea
                            type='text'
                            className='form-input'
                            name='status'
                            value={status || ''}
                            onChange={(e) => onChange(e)}
                            autoComplete="off"
                        />
                        :
                        <p>{user.status}</p>
                }
            </div>
            <form className='form' onSubmit={(e) => onSubmit(e)}>
                <div className='profile-container'>
                    <div>
                        <label className="label">Email</label>
                        <h4>{user.email}</h4>
                    </div>
                    <div>
                        <label className="label">Name</label>
                        {
                            isEdit ?
                                <input
                                    type='text'
                                    className='form-input'
                                    name='name'
                                    value={name || ''}
                                    onChange={(e) => onChange(e)}
                                    autoComplete="off"
                                />
                                :
                                <h4>{user.name}</h4>
                        }
                    </div>
                    <div>
                        <label className="label">Mobile Number</label>
                        {
                            isEdit ?
                                <input
                                    type='tel'
                                    className='form-input'
                                    name='phone'
                                    value={phone || ''}
                                    onChange={(e) => {
                                        e.target.value = e.target.value.replace(/\D/g, "");
                                        onChange(e)
                                    }}
                                    pattern="[0-9]{11}"
                                    title="Please enter 11 number format."
                                    autoComplete="off"
                                />
                                :
                                <h4>{user.phone}</h4>
                        }
                    </div>
                    <div>
                        <label className="label">Birthdate</label>
                        {
                            isEdit ?
                                <input
                                    type='date'
                                    className='form-input'
                                    name='birthDate'
                                    value={birthDate || ''}
                                    onChange={(e) => onChange(e)}
                                    autoComplete="off"
                                />
                                :
                                <h4>{user.birthDate}</h4>
                        }
                    </div>
                    <div>
                        <label className="label">Location</label>
                        {
                            isEdit ?
                                <input
                                    type='text'
                                    className='form-input'
                                    name='location'
                                    value={location || ''}
                                    onChange={(e) => onChange(e)}
                                    autoComplete="off"
                                />
                                :
                                <h4>{user.location}</h4>
                        }
                    </div>

                    <input type='submit' className={`sign-button ${isEdit ? null : 'hidden'}`} value='Save changes'/>
                </div>
            </form>
        </Container>

    );
}

Settings.propTypes = {
    user: PropTypes.object,
    updateProfile: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    user: state.auth.user,
});

export default connect(mapStateToProps, {updateProfile})(Settings);

const Container = styled.div`
  background-color: #F5F7FB;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0px 24px;
  border-left: #ECEDF6 solid 2px;
  border-right: #ECEDF6 solid 2px;
  overflow-y: auto;

  @media screen and (max-width: 1000px) {
    .header {
      margin-top: 59px;
    }
  }
}

&::-webkit-scrollbar {
  width: 0.2rem;

  &-thumb {
    background-color: #D1D6DB;
    width: 0.1rem;
    border-radius: 1rem;
  }
}

.header {
  padding-top: 12px;
  padding-bottom: 24px;
}

.avatar-container {
  text-align: center;
  border-bottom: #F0EFF5 1px solid;
  padding-bottom: 35px;

  .avatar-image-container {
    position: relative;
  }

  .avatar {
    width: 5rem;
    padding: 15px;
    display: inline-block;
    cursor: pointer;
  }

  .avatar-icon {
    font-size: 6rem;
    padding-bottom: 15px;
  }

  .avatar-edit {
    position: absolute;
    bottom: 13px;
    right: 8px;
    background-color: #E6EBF5;
    border-radius: 50%;
    padding: 10px;
    cursor: pointer;
  }

  h4 {
    font-weight: 500;
  }

  .select-container {
    position: relative;

    .spinner-container {
      display: flex;
      justify-content: center;
      padding-top: 50px;
    }
  }

  .select-box {
    background-color: #E6EBF5;
    position: absolute;
    z-index: 1;
    border-radius: 0.5rem;
  }
}

.status-container {
  position: relative;
  padding-top: 50px;
  padding-bottom: 35px;

  p {
    font-size: 0.9rem;
    color: #7A7FB3;
  }

  .profile-edit {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 15px;
    right: 0px;
    background-color: #E6EBF5;
    padding: 6px 7px;
    cursor: pointer;
    border-radius: 0.25rem;
    gap: 5px;
  }

  textarea {
    height: 75px;
  }
}

.profile-container {
  background-color: white;
  padding: 20px 20px;
  font-size: 0.9rem;

  div {
    padding-bottom: 25px;
  }

  > div:last-child {
    padding-bottom: 0;
  }

  .label {
    display: block;
    margin-bottom: 0.3rem;
    color: #7A7FB3;
  }

  h4 {
    font-weight: 500;
  }

  .sign-button {
    width: 100%;
    margin-top: 1rem;
    cursor: pointer;
    color: #fff;
    background-color: #7269ef;
    line-height: 1.5;
    padding: 0.65rem 1rem;
    border-radius: 0.25rem;
    border: none;
    transition: 0.25s;
    font-size: 0.9rem;

    :hover {
      background-color: #6159cb;
      border-color: #5b54bf;
    }
  }
}

.form-input {
  width: calc(100% - 1rem);
  padding: 0.25rem 0.5rem;
  font-size: .875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #7a7f9a;
  background-color: #f5f7fb;
  border: 1px solid #e6ebf5;
  border-bottom-right-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.hidden {
  display: none !important;
}
`;